import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { LoginService } from '../login-form/login-form.service';
import { Location } from '@angular/common';
import { HttpService } from 'src/app/services/http/http.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SocialAuthService } from "angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
import { SocialUser } from "angularx-social-login";
import { Spinkit } from 'ng-http-loader';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { interval } from "rxjs";
@Component({
  selector: 'register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss']
})
export class RegisterFormComponent implements OnInit {
  public spinkit = Spinkit;
  registerForm: FormGroup;
  ids
  tableids
  errorMessage: any;
  quiz_id: any;
  encodedtoken: any;
  encodedURL: string;
  userType: any;
  emailId: string;
  nameCondition = false
  referal_id
  encodedURL_referal
  userNewName: string = ''
  constructor(private _location: Location, private authService: SocialAuthService, private httpS: HttpService, private fb: FormBuilder, private loginService: LoginService,
    private router: Router, private route: ActivatedRoute, private spinner: SpinnerVisibilityService) { }

  ngOnInit() {
    this.ids = sessionStorage.getItem('restoIds')
    this.tableids = sessionStorage.getItem('tableIds')
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      mobile: [],
      email: ['', [Validators.required, Validators.email]],
      pass: ['', Validators.required]
    });

    this.route.queryParams.subscribe(params => {
      this.quiz_id = params['identity'];
      this.referal_id = params['referal']
      if (this.quiz_id) {
        sessionStorage.clear();
        this.encodedURL = encodeURIComponent(this.quiz_id)
      }
      if (this.referal_id) {
        this.encodedURL_referal = atob(this.referal_id);
      }
      sessionStorage.setItem('signupPage', 'true')
      this.sessionStorageFunction()

    })
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    let temp = document.getElementById("googleLOGINIcon");
    document.getElementById("googleOnSingUp").appendChild(temp);
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    sessionStorage.removeItem('signupPage')
  }
  backClicked() {
    this.ngOnInit();
    this.router.navigate(['/public/sign-in']);

  }
  submitRegistrationForm() {
    this.loginService.register(this.registerForm.value).subscribe(res => {
      if (res['status'] == true) {
        sessionStorage.setItem('access_token', res.result.authToken);
        sessionStorage.setItem('currentUser', JSON.stringify(res.result.userDetails));
        sessionStorage.setItem('userName', res.result.userDetails.userName)
        let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
        // this.tasteDetails();

        if (showMenuClicked) {
          this.userPreferenceChange();
        } else {

          if (this.quiz_id) {
            this.router.navigate(['/horizontal/userprofile'])
            this.tasteDetailsput();
          }
          else {
            this.router.navigate(['/horizontal/choose-preference']);
          }
        }
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message
      Swal.fire(this.errorMessage);
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
    })
  }




  tasteDetailsput() {
    if (this.quiz_id && this.referal_id) {
      let data = {
        token: this.encodedURL,
        self_friend_id: this.encodedURL_referal
      }
      this.httpS.tasteDetailsput(data).subscribe(res => {
        if (res['status'] == true) {
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message
        if (err.status == 401) {
          this.logout();

        }
        else if (err.status == 500) {
          this.logout();
        }
      })
    }
    else {
      let data = {
        token: this.encodedURL,
      }
      this.httpS.tasteDetailsput(data).subscribe(res => {
        if (res['status'] == true) {

        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message
        if (err.status == 401) {
          this.logout();

        }
        else if (err.status == 500) {
          this.logout();
        }
      })
    }
  }
  userPreferenceChange() {
    const allrgArray = JSON.parse("[" + sessionStorage.getItem("selectedAlleregence") + "]");
    const dietArray = JSON.parse("[" + sessionStorage.getItem("diestPrefArray") + "]");
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
    let showMyOrderClicked = sessionStorage.getItem("isGuestShowMyOrderClicked") ? sessionStorage.getItem("isGuestShowMyOrderClicked") : false;

    const data = {
      allergens: allrgArray,
      dietary: dietArray,
      spice_rating_all: sessionStorage.getItem("spiceRating"),
      cross_contamination: sessionStorage.getItem("crosscontamination") ? 'Yes' : 'No'

    }
    this.httpS.postUserPreference(data).subscribe(res => {
      if (res['status'] == true) {
        let showprofile = sessionStorage.getItem("guestTouserProfile");
        let showorders = sessionStorage.getItem("guestToOrders");
        if (showMenuClicked == "true" && showprofile == "true") {
          this.router.navigate(['/horizontal/profile']);
        }
        else if (showMenuClicked == "true" && showorders == "true") {
          this.router.navigate(['/horizontal/order-list']);
        }

      }
    }, err => {
      console.log(err);

    });




    // swalWithBootstrapButtons.fire({
    //   title: 'Are you sure?',
    //   text: "You you want to update the preferences!",
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonText: 'Yes',
    //   cancelButtonText: 'No',
    //   reverseButtons: true
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     // swalWithBootstrapButtons.fire(
    //     //   'Deleted!',
    //     //   'Your file has been deleted.',
    //     //   'success'
    //     // )
    //     this.router.navigate(['/horizontal/choose-preference']);




    //   } else if (
    //     /* Read more about handling dismissals below */
    //     result.dismiss === Swal.DismissReason.cancel
    //   ) {
    //     let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
    //     let showMyOrderClicked = sessionStorage.getItem("isGuestShowMyOrderClicked");
    //     const data = {
    //       allergens:allrgArray,
    //       dietary:dietArray,
    //       spice_rating_all:sessionStorage.getItem("spiceRating")
    //     }
    //      this.httpS.postUserPreference(data).subscribe(res =>{
    //      if(res['status'] == true){
    //        if(showMenuClicked == "true" && showMyOrderClicked == "true" )
    //          this.router.navigate(['/horizontal/order-menu']);
    //        }else if(showMenuClicked == "true"){
    //         this.router.navigate(['/horizontal/food-menu']);
    //        }
    //      },err=>{

    //      })

    //     // swalWithBootstrapButtons.fire(
    //     //   'Cancelled',
    //     //   'Your imaginary file is safe :)',
    //     //   'error'
    //     // )
    //   }
    // })
  }

  logout() {
    let token = sessionStorage.getItem("access_token");
    this.httpS.logouts(token).subscribe(
      response => {
        if (response['status'] == true) {
          sessionStorage.clear();
          this.router.navigate(['public/resto'], { queryParams: { id: this.ids, table_id: this.tableids } });
        }
        else {
          Swal.fire("Something Went Wrong")
        }
      }
    )
  }

  signInWithGoogle() {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID).then((userData) => {
      // console.log("Googledata", userData)
      const datas = {
        email: userData['email'],
        name: userData['name'],
        source: "Google"
      }
      this.loginService.postLoginSocial(datas).subscribe(response => {

        if (response['status'] == true) {
          const data = {
            accessToken: response.result.authToken,
            restoID: response.result.userDetails.restaurant_id,
          };
          sessionStorage.setItem('access_token', data.accessToken);
          sessionStorage.setItem('restoID', data.restoID);
          sessionStorage.setItem('restoIDCopy', data.restoID);
          sessionStorage.setItem('userName', response.result.userDetails.userName);
          sessionStorage.setItem('currentUser', JSON.stringify(data));
          this.userType = response.result.userDetails.userType
          let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
          if (showMenuClicked) {
            this.userPreferenceChange();
          }
          else {
            if (this.quiz_id) {
              this.router.navigate(['/horizontal/userprofile'])
              this.tasteDetailsput();
            }
            else {
              this.router.navigate(['/horizontal/choose-preference']);
            }
          }
        }

      },
        (err: HttpErrorResponse) => {
          console.log('get configuration error', err);
        });
    });


  }
  signInWithFB() {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('currentUser');
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID).then((userData) => {
      // console.log("fbuserdata", userData)
      const data = {
        email: userData['email'],
        name: userData['name'],
        source: "Facebook"
      }
      this.loginService.postLoginSocial(data).subscribe(response => {
        if (response['status'] == true) {
          const data = {
            accessToken: response.result.authToken,
            restoID: response.result.userDetails.restaurant_id,

          };
          sessionStorage.setItem('access_token', data.accessToken);
          sessionStorage.setItem('restoID', data.restoID);
          sessionStorage.setItem('restoIDCopy', data.restoID);
          sessionStorage.setItem('userName', response.result.userDetails.userName);
          sessionStorage.setItem('currentUser', JSON.stringify(data));
          this.userType = response.result.userDetails.userType
          let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
          if (showMenuClicked) {
            this.userPreferenceChange();
          }
          else {
            if (this.quiz_id) {
              this.router.navigate(['/horizontal/userprofile'])
              this.tasteDetailsput();
            }
            else {
              this.router.navigate(['/horizontal/choose-preference']);
            }
          }
        }
        else {
          Swal.fire("Something Went Wrong")
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message
        if (err.status == 401) {
          this.logout();

        }
        else if (err.status == 500) {
          this.logout();
        }
      })
    });
  }
  emailNotValid = false
  validFunc() {
    this.emailNotValid = false
  }
  otpData: any = ''
  otpCoditon = true
  sendOtpByEmail() {
    if (this.emailId.includes('@') && this.emailId.includes('.') && this.emailId.length > 2) {
      this.otpCoditon = false
      this.httpS.sendOtpByEmail(this.emailId).subscribe((res: any) => {
        const b64 = res.result.data; // base64 string
        const decodedStr = atob(b64); // -> JSON string (if it was encoded as plain ASCII/UTF-8)
        const decodedObj = JSON.parse(decodedStr);

        this.otpData = decodedObj.otp;
        // this.otpData = res['result'].data.otp                                                                                                                                                                                                                                                                                                      
      })
    }
    else {
      this.emailNotValid = true
    }

  }
  showErrorMessage = false
  otpValue: any
  onOtpChange(e: any) {
    if (e.length == 4) {
      this.otpValue = e;
      this.verifyOtp(e);
    }
    else if (this.showErrorMessage) {
      this.showErrorMessage = false
    }
  }
  verifyOtp(e) {
    if (this.otpData == parseInt(e)) {
      let otpObj = {
        email: this.emailId,
        otp: this.otpValue,
      };
      this.httpS.verifyOTPUser(otpObj).subscribe((response: any) => {
        if (response['result'].userDetails.userName) {
          sessionStorage.setItem('access_token', response.result.token);
          sessionStorage.setItem('currentUser', JSON.stringify(response.result.userDetails));
          sessionStorage.setItem('userName', response.result.userDetails.userName)
          let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
          if (showMenuClicked) {
            this.userPreferenceChange();
          } else {

            if (this.quiz_id) {
              this.router.navigate(['/horizontal/aggregator'])
              this.tasteDetailsput();
            }
            else {
              this.router.navigate(['/horizontal/aggregator']);
            }
          }
        }
        else {
          sessionStorage.setItem('access_token', response.result.authToken);
          sessionStorage.setItem('currentUser', JSON.stringify(response.result.userDetails));
          this.nameCondition = true
        }
      })
    }
  }
  resendOtp() {
    this.sendOtpByEmail();
  }
  nameNextCondition: boolean = true
  nextBtnConditionFunc() {
    if (this.userNewName.length > 0) {
      this.nameNextCondition = false
    }
  }
  nameNextBtn() {
    let profileObj = {
      name: this.userNewName,
    };
    this.httpS.updateProfile(profileObj).subscribe(
      (res: any) => {
        if (res["status"] == "TRUE") {
          sessionStorage.setItem('userName', this.userNewName)
          let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
          if (showMenuClicked) {
            this.userPreferenceChange();
          } else {

            if (this.quiz_id) {
              this.router.navigate(['/horizontal/userprofile'])
              this.tasteDetailsput();
            }
            else {
              this.router.navigate(['/horizontal/choose-preference']);
            }
          }
        }
      });
  }
  googleLogin() {

  }
  sessionStorageFunction() {
    // Checking the google credential in local storage in every one second
    let data = interval(1000).subscribe(() => {

      let flag = sessionStorage.getItem("goodleLoginCredential");
      if (flag) {
        //stopping the interval if credential found
        // data.unsubscribe();

        // Changing JSON token to object
        var base64Url = flag.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        let finalData = JSON.parse(jsonPayload);

        let user = {
          name: finalData["name"],
          email: finalData["email"],
          source: "Google",
        }
        if (sessionStorage.getItem('signupPage') && !sessionStorage.getItem('access_token')) {
          this.loginService.postLoginSocial(user).subscribe(res => {
            if (res["status"] == true) {
              data.unsubscribe()
              sessionStorage.setItem('access_token', res.result.authToken);
              sessionStorage.setItem('currentUser', JSON.stringify(res.result.userDetails));
              sessionStorage.setItem('userName', res.result.userDetails.first_name)
              let showMenuClicked = sessionStorage.getItem("isGuestShowMenuClicked");
              if (showMenuClicked) {
                this.userPreferenceChange();
              } else {

                if (this.quiz_id) {
                  this.router.navigate(['/horizontal/aggregator'])
                  this.tasteDetailsput();
                }
                else {
                  this.router.navigate(['/horizontal/aggregator']);
                }
              }

            }
          })
        }
        else if (!sessionStorage.getItem('signupPage') && sessionStorage.getItem('access_token')) {
          data.unsubscribe()
        }
      }
    })
  }
}
